import CardList from "../../modules/cardList/CardList";
import Section from "../../modules/section/Section";
import { useTranslation } from "react-i18next";
import dimitrov from "../../../assets/images/ourpeople1.jpeg";
import jane from "../../../assets/images/ourpeople4.jpeg";
import katarina from "../../../assets/images/ourpeople2.jpeg";
import nadica from "../../../assets/images/ourpeople3.jpeg";
import ivona from "../../../assets/images/ourpeople5.jpeg";
import vesna from "../../../assets/images/ourpeople8.jpeg";
import keti from "../../../assets/images/image00031.jpeg";
import martina from "../../../assets/images/ourpeople7.jpeg";

const OurPeople = () => {
  const { t } = useTranslation();
  const people = [
    {
      title: t("GeorgiDimitrov"),
      superTitle: t("managingPartner"),
      link: "georgi-dimitrov",
      src: dimitrov,
      srcMob: dimitrov,
    },
    {
      title: t("KatarinaGinoska"),
      superTitle: t("partner"),
      link: "katarina-ginoska",
      src: katarina,
      srcMob: katarina,
    },
    {
      title: t("NadicaPetrusevska"),
      superTitle: t("partner"),
      link: "nadica-petrusevska",
      src: nadica,
      srcMob: nadica,
    },
    {
      title: t("JaneIlijeski"),
      superTitle: t("partner"),
      link: "jane-ilijeski",
      src: jane,
      srcMob: jane,
    },
    {
      title: t("IvonaMitrevska"),
      superTitle: t("seniorAttorney"),
      link: "ivona-mitrevska",
      src: ivona,
      srcMob: ivona,
    },
    {
      title: t("KetiGligorjadis"),
      superTitle: t("attorney"),
      link: "keti-gligorjadis",
      src: keti,
      srcMob: keti,
    },
    {
      title: t("MartinaAngelovska"),
      superTitle: t("attorney"),
      link: "martina-angelovska",
      src: martina,
      srcMob: martina,
    },
    {
      title: t("VesnaPanevska"),
      superTitle: t("administrativeAssistant"),
      link: "vesna-panevska",
      src: vesna,
      srcMob: vesna,
    },
  ];

  return (
    <>
      <Section>
        <CardList cards={people} isOurPeople />
      </Section>
    </>
  );
};

export default OurPeople;
